import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

(function ($) {
  let $redLineObject = $(".container-red-line");
  let arrLeonardGTMTrackingFormPath = [];
  let menuWidth = 1280;

  $(document).ready(function () {
    dinamoRedirectContactForm();
    initLeonardGTMTracking();

    $(document).on(
      "click",
      ".main-header-menu .menu-open, .main-header-menu .close-button",
      dinamoToggleOverlayMenu
    );
    $(document).on(
      "click",
      ".main-menu-mobile .menu > li.menu-item-has-children > a",
      dinamoHeaderOpenSubMenu
    );
    $(document).on(
      "click",
      ".search-toggle-button, .search-close-button",
      dinamoToggleSearchOverlay
    );

    $(window).scroll(function () {
      debounce(dinamoHandleScroll, 25);
    });

    // Modal functionality
    var $modal = $('#videoModal');
    var $iframe = $('#videoIframe');

    $('.btn-video').on('click', function (e) {
        e.preventDefault();
        var videoId = $(this).data('video-id');
        $iframe.attr('src', 'https://www.youtube.com/embed/' + videoId);
        $modal.removeClass('hidden').addClass('flex');
    });

    $('.close, #videoModal').on('click', function (e) {
        if (e.target === this) {
            $modal.removeClass('flex').addClass('hidden');
            $iframe.attr('src', '');
        }
    });

    if($('#videoModal').length) {
      $('#videoModal').click(function(e) {
        if(!$('#videoModal').hasClass('modal-closed')) {
          var container = $("#videoIframe");

          if (!container.is(e.target) && container.has(e.target).length === 0) {
            $modal.removeClass('flex').addClass('hidden');
          }
        }
      });

      $('.flexible-gallery .gallery .gallery-item-video').click(function(e) {
        if($(this).data('video-url')) {
          $('.flexible-gallery-modal-video').attr('src', $(this).data('video-url'));
          $('.flexible-gallery .flexible-gallery-modal').toggleClass('modal-closed');
        }
      });
    };

    $('.page-template-template-careers .filter-link').on('click', function (e) {
      e.preventDefault();

      let selected_type = '.job-' + $(this).data('type');

      $('.filter-link').each(function(index) {
        $(this).removeClass('tax-active');
      });

      $(this).addClass('tax-active');

      $('.job-item').each(function(index) {
        if(selected_type != '.job-all'){
          $(this).hide();
        }
        else{
          $(this).show();
        }
      });

      $(selected_type).each(function(index) {
        $(this).show();
      });

      let selected_count = $(selected_type).size();

      $('#filters-results').html(selected_count);
  });

    $(document).on(
      "touchstart",
      ".main-menu .menu > li.menu-item-has-children > a",
      dinamoTouchStart
    );

    //Trigger the scroll management function also on first load
    dinamoHandleScroll();

    //Set the container red line height after 1.5 seconds of the page load
    debounce(dinamoInitRedLineHeight, 1500);
    //Init the scroll red line animation after its initial height has been set
    setTimeout(() => {
      $redLineObject.css("transition", "none");
      $(window).scroll(function () {
        if ($redLineObject.length > 0 && $redLineObject.hasClass("animated")) {
          dinamoAnimateRedLine();
          debounce(dinamoToggleRedDotVisibility, 25);
        }
      });
    }, 2500);
    //Init the visibility of the red dots one time on load
    setTimeout(() => {
      if ($redLineObject.length > 0 && $redLineObject.hasClass("animated")) {
        dinamoToggleRedDotVisibility();
      }
    }, 3000);

    //swipers
    if ($(".dinamo-home-swiper").length) {
      dinamoHomeSwiper();
    }
    if ($(".dinamo-articles-swiper").length) {
      dinamoArticlesSwiper();
    }
    if ($(".dinamo-two-swiper").length) {
      dinamoTwoSwiper();
    }
    if ($(".dinamo-project-swiper").length) {
      dinamoProjectImageSwiper();
    }
    if ($(".dinamo-project-swiper2").length) {
      dinamoProjectImageSwiper2();
    }
    if ($(".dinamo-testimony-swiper").length) {
      dinamoTestimonySwiper();
    }
    if ($(".dinamo-work-swiper").length) {
      dinamoWorkSwiper();
    }

    if($('.single-jobs').length && $('#job_type').length){
      $('#job_type').attr('value', $('.single-jobs h1').text());
  }
  });

  function dinamoTouchStart(e) {
    if (window.innerWidth > menuWidth) {
      $(".main-menu").addClass("prevent-tablet");
    }
  }

  // Handle scroll events (ie: fexed menu background)
  function dinamoHandleScroll() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 50) {
      $(".main-header-menu").addClass("scrolled");
    }
    if (scrollTop == 0) {
      $(".main-header-menu").removeClass("scrolled");
    }
  }

  function dinamoRedirectContactForm() {
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        let redirectUrl = $("input[name=redirect_url]").val();
        if (redirectUrl != undefined) {
          location = redirectUrl;
        }
      },
      false
    );
  }

  function initLeonardGTMTracking() {
    // Track CTA pointing to a «Leads Form»
    // -------
    let arrLeonardGTMTrackingCTA = [];

    for (let i = 0; i < arrLeonardGTMTrackingFormPath.length; i++) {
      arrLeonardGTMTrackingCTA.push(
        "a.p-btn[href*='" +
          arrLeonardGTMTrackingFormPath[i] +
          "'], a.p-button[href*='" +
          arrLeonardGTMTrackingFormPath[i] +
          "']"
      );
    }

    // Custom CSS rules here
    // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");

    $(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");

    // Track «Leads form» submit button click
    // -------
    if (arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
      $("form button, form input[type=submit]").addClass("gtm-form-submited");
    }
  }

  // Open and closes the mobile menu
  function dinamoToggleOverlayMenu(e) {
    $(".mobile-menu").toggleClass("opened");
    $("body").toggleClass("opened");

    if ($(".search-overlay").hasClass("opened")) {
      $(".search-overlay").removeClass("search-opened");
    }
    e.preventDefault();
  }

  //Open or closes the search overlay
  function dinamoToggleSearchOverlay(e) {
    //Close the mobile menu if opened
    if ($(".mobile-menu").hasClass("opened")) {
      dinamoToggleOverlayMenu(e);
    }
    $("body").toggleClass("opened");
    $(".search-overlay").toggleClass("opened");

    //Focus on the search input
    if ($(".search-overlay").hasClass("opened")) {
      $(".search-overlay input").focus();
    }
  }

  /**
   * Open the mobile sub menu items on the parent link click
   */
  function dinamoHeaderOpenSubMenu(e) {
    let subMenuSelected = "";
    let isOpened = $(this).parent().hasClass("opened") ? true : false;
    let allSubMenu = $(this)
      .parent()
      .parent()
      .find(".sub-menu")
      .not($(this).parent().find(".sub-menu"));

    subMenuSelected = $(this).parent().find(".sub-menu").first();

    let allMenuLi = $(this)
      .closest("ul.menu")
      .children("li")
      .not($(this).parents("li"));

    $(this).parent().removeClass("opened");
    $(this).closest("ul.sub-menu").children("li").removeClass("opened");
    allMenuLi.removeClass("opened");

    if (!isOpened) {
      $(this).parent().addClass("opened");
    }

    allSubMenu.removeClass("sub-menu-opened");
    subMenuSelected.toggleClass("sub-menu-opened");

    e.preventDefault();
  }

  function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId = setTimeout(function () {
      method();
    }, delay);
  }

  /**
   * Function that initialize our container red line height automatically on page load. Finds the first ".red-line-dot" element on the page and set the height so our line reaches it.
   */
  function dinamoInitRedLineHeight() {
    if ($redLineObject.length > 0) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let viewportHeight = window.innerHeight;
      let twoThirdOfViewport = (viewportHeight / 3) * 2;
      let twoThirdOfCurrentScrollOffset = twoThirdOfViewport + scrollTop;

      let firstDotOffset = $(".red-line-dot").first().offset();
      if (firstDotOffset) {
        let lastDotOffset = $(".red-line-dot").last().offset();
        let firstHeight = firstDotOffset.top;
        // If the initial page load is below our first red dot position, set the height to 2/3 of the scroll insteaf of our first red dot element's Y offset
        if (scrollTop > firstHeight) {
          firstHeight = twoThirdOfCurrentScrollOffset;
        }
        //If the first height is bigger thant our last dot Y offset, we set the heaight to the last dot offset so there's no overflow
        if (firstHeight > lastDotOffset.top) {
          firstHeight = lastDotOffset.top + $(".red-line-dot").last().height();
        }

        $redLineObject.css("height", firstHeight);
        $redLineObject.data("first-dot-height", firstDotOffset.top);
        $redLineObject.data("last-dot-height", lastDotOffset.top);
        dinamoToggleRedDotVisibility();
      }
    }
  }

  /**
   * Function that takes care of changing our container red line's height on scroll
   */
  function dinamoAnimateRedLine() {
    let viewportHeight = window.innerHeight;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let twoThirdOfViewport = (viewportHeight / 3) * 2;
    let newHeight = twoThirdOfViewport + scrollTop;
    let $lastDot = $(".red-line-dot").last();
    let lastDotOffset = $lastDot.offset();

    if (newHeight > $redLineObject.data("last-dot-height")) {
      newHeight = $redLineObject.data("last-dot-height") + $lastDot.height();
    }
    //If the 2/3 height of the page is higher than our line's initial height, it means that we have to adjust its height property
    if ($redLineObject.data("first-dot-height") > newHeight) {
      newHeight = $redLineObject.data("first-dot-height");
    }

    $redLineObject.css("height", newHeight);
  }

  /**
   * Function that handles our red dots visibility when we have an animated red line. If the line crosses a dot, we display it. Otherwise, we hide it.
   */
  function dinamoToggleRedDotVisibility() {
    $(".red-line-dot")
      .not(".first")
      .each(function () {
        let dotOffset = $(this).offset().top;
        //If the dot Y offset is greter than our line's height, it means that we haven't got to it yet so we hide it. Otherwise, we display it.
        if (dotOffset >= $redLineObject.height()) {
          $(this).css("opacity", "0");
        } else {
          $(this).css("opacity", "1");
        }
      });
  }

  //Swipers
  function dinamoHomeSwiper() {
    let swiperHomeSlider = new Swiper(".dinamo-home-swiper", {
      slidesPerView: 1,
      loop: true,
      autoplay: true,
      delay: 5000,
      effect: "fade",
      crossFade: true
    });
  }
  function dinamoArticlesSwiper() {
    let swiperArticlesTypeSlider = new Swiper(".dinamo-articles-swiper", {
      slidesPerView: 1.2,
      spaceBetween: 25,
      autoplay: false,
      breakpoints: {
        640: {
          slidesPerView: 1.2,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
  function dinamoTwoSwiper() {
    let swiperTwoSlider = new Swiper(".dinamo-two-swiper", {
      slidesPerView: 1.2,
      spaceBetween: 25,
      autoplay: false,
      breakpoints: {
        640: {
          slidesPerView: 1.2,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  function dinamoProjectImageSwiper2() {
    let swiperProject2 = new Swiper(".dinamo-project-swiper2", {
      slidesPerView: 1.7,
      spaceBetween: 20,
      autoplay: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  function dinamoProjectImageSwiper() {
    const prevButton = $(".swiper-button-prev-projectImg");
    const nextButton = $(".swiper-button-next-projectImg");
    var swiper = new Swiper(".dinamo-project-swiper", {
      navigation: {
        nextEl: ".swiper-button-next-projectImg",
        prevEl: ".swiper-button-prev-projectImg",
      },
    });
  }

  function dinamoTestimonySwiper() {
    var swiper = new Swiper(".dinamo-testimony-swiper", {
      navigation: {
        nextEl: ".swiper-button-next-testimony",
        prevEl: ".swiper-button-prev-testimony",
      },
      pagination: {
        el: ".swiper-pagination-testimony",
        clickable: true,
      },
    });
  }

  function dinamoWorkSwiper() {
    var swiper = new Swiper(".dinamo-work-swiper", {
      slidesPerView: 1,
      autoplay: false,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next-work",
        prevEl: ".swiper-button-prev-work",
      },
    });
  }
  //  Industries Function to display the description according to the index
  function dinamoDisplayDescription(index) {
    $('[class*="contenu_industry-' + index + '"]').show();
    $(
      '[class*="contenu_industry-"]:not(.contenu_industry-' + index + ")"
    ).hide();
  }

  $('[id^="industry-"]').on("mouseover", function () {
    const index = $(this).data("industry-index");
    $('[id^="industry-"]').removeClass("active");
    dinamoDisplayDescription(index);
  });

  $('[id^="industry-"]').on("click", function (e) {
    const index = $(this).data("industry-index");
    $('[id^="industry-"]').removeClass("active-industry");
    $(this).addClass("active-industry");
    dinamoDisplayDescription(index);
  });

  $('[class*="contenu_industry-"]:not(.contenu_industry-1)').hide();
  // $('[id^="industry-"]:first').addClass("active-industry");
})(jQuery);